/**
 * Default locale for the main site. Used to prefix all main app routes until
 * full i18n is implemented.
 */
export const DEFAULT_LOCALE = "de";

/**
 * Prefixes a path with the locale segment for main-site URLs.
 * Use for all internal links and redirects to main app routes.
 *
 * @example
 * withLocale("/")           // "/de"
 * withLocale("/search")     // "/de/search"
 * withLocale("/de/search")  // "/de/search" (idempotent if already prefixed)
 */
export function withLocale(path: string, locale: string = DEFAULT_LOCALE): string {
  const normalized = path === "/" ? "" : path.replace(/^\/+/, "");
  if (normalized.startsWith(`${locale}/`) || normalized === locale) {
    return path.startsWith("/") ? path : `/${path}`;
  }
  return `/${locale}${normalized ? `/${normalized}` : ""}`;
}
